/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadOnlyModule
 */
export interface ReadOnlyModule {
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyModule
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyModule
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyModule
     */
    label?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyModule
     */
    deleted: number;
    /**
     * 
     * @type {object}
     * @memberof ReadOnlyModule
     */
    features?: object;
}

export function ReadOnlyModuleFromJSON(json: any): ReadOnlyModule {
    return ReadOnlyModuleFromJSONTyped(json, false);
}

export function ReadOnlyModuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyModule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'deleted': json['deleted'],
        'features': !exists(json, 'features') ? undefined : json['features'],
    };
}

export function ReadOnlyModuleToJSON(value?: ReadOnlyModule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'label': value.label,
        'deleted': value.deleted,
        'features': value.features,
    };
}


